module.exports = __webpack_public_path__ + "img/HKIBFA-logo.a1771da1.png";